import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
  palette: {
    type: 'light',
    primary: {
      main: '#fb8c00',
      dark: '#e64a19',
      contrastText: '#eff8f8',
    },
    secondary: {
      main: '#6a103e',
      contrastText: '#eff8f8',
    },
    text: {
      primary: '#616161',
    },
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        a: {
          display: 'inline-block',
        },
      },
    },
  },
  typography: {
    button: {
      textTransform: 'none',
    },
    h1: {
      fontSize: 32,
      fontWeight: 600,
      textTransform: 'lowercase',
    },
    h2: {
      fontSize: 28,
      fontWeight: 500,
      textTransform: 'lowercase',
    },
    h3: {
      fontSize: 24,
      textTransform: 'lowercase',
    },
    h4: {
      fontSize: 20,
      textTransform: 'lowercase',
    },
    h5: {
      fontSize: 16,
      textTransform: 'lowercase',
    },
    h6: {
      fontSize: 12,
      textTransform: 'lowercase',
    },
  },
});

export default theme;
